import React, { useMemo, useState,useEffect  } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import { newProductRequest } from "../../../common/data/MyFackData";

const NewProduct = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
    const imgurl = process.env.REACT_APP_IMAGE_URL;
  
  const [error, setError] = useState(null);
   const [newProductData, setNewProductData] = useState([]);
  
  const fetchnewProductData = async () => {
        try {
          setError(null); // Reset error before fetching
          const response = await fetch(`${baseurl}/contact/newporductlist`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setNewProductData(data);
        } catch (error) {
          setError(error.message);
        }
      };
    useEffect(() => {
          fetchnewProductData();
        }, []);
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Username",
        accessor: "username",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      
      {
        Header: "Product Name",
        accessor: "product_name",
        filterable: true,
      },
      {
        Header: "Manufacture part No",
        accessor: "manufacturing_part_number",
        filterable: true,
      },
      {
        Header: "Brand Name",
        accessor: "brand_name",
        filterable: true,
      },
      {
        Header: "Contact no.",
        accessor: "mobile",
        filterable: true,
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
      },
      // {
      //   Header: "Action",
      //   accessor: "action",
      //   filterable: true,
      //   Cell: ({ row }) => {
      //     return (
      //       <ul className="list-unstyled hstack gap-1 mb-0">
      //         <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
      //           <Link to="#" className="btn btn-sm btn-soft-primary">
      //             <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
      //           </Link>
      //         </li>
      //         <UncontrolledTooltip placement="top" target="viewtooltip">
      //           View
      //         </UncontrolledTooltip>
      //       </ul>
      //     );
      //   },
      // },
    ],
    []
  );

  document.title = "User New Product reuest | Admin";

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs
            title="New Product"
            breadcrumbItem="User New Product List"
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={newProductData}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default withRouter(NewProduct);
